import { Accordion } from 'components/Accordion';
import styled from 'styled-components/macro';

export const Title = styled.h2`
  font-size: 21px;
  color: #444;
  margin: 0;
`;

export const SubTitle = styled.h3`
  font-size: 16px;
  line-height: 24px;
  color: #444;
  margin-bottom: 15px;
`;

export const BreadCrumbs = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  font-size: 11px;
  color: #444;
  font-weight: 500;
  flex: 1;
`;

export const Hr = styled.hr`
  border-color: #d1d1d1;
  border-width: 2px;
  width: 100%;
  margin: 50px 0;
`;

export const Container = styled.div`
  margin-bottom: 75px;
`;

export const PerformanceReturnAccordion = styled(Accordion)`
  border: none !important;
  margin: 0;
  padding: 0;
`;

export const AccordionContent = styled.div`
  width: 100%;
  margin-top: 30px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;
